import React, {Component} from 'react';
import axios from 'axios'

import FileUpload from '../commons/components/FileUpload'
import CS from '../commons/services/Common'
import VS from '../commons/services/Validation'
import { withTranslation } from 'react-i18next';

/**
 * 회원가입 컴포넌트
 */
class Signup extends Component {
    constructor(props) {
        super(props);
        this.state = {
            idDuplicateMsg: ''
        }

        this.fileInfo = {};
        this.isIdDuplicate = true;
        this.isCorp = false;
        this.bizNum = '';

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleInputChange = (event) => {
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value; 
        //여기서 3항연산자를 통해 checkbox인 경우 checked만 체크. 아닌경우 밸류체크
        const name = target.name;
        this.setState({
            [name]: value
        });
    }

    doSetFile = (category, fileInfos) => {
        this.fileInfo[category] = fileInfos;
    }

    idCheck = async () => {
        const { t } = this.props;
        let res = await axios.get("/api/account/id-check/" + CS.$("#userId"));
        this.isIdDuplicate = res.data.result
        this.setState({
            idDuplicateMsg: this.isIdDuplicate ? t("key691") : t("key692")
        })
    }

    isCorpCheck = () => {
        const { t } = this.props;
        let bizNum = CS.$("#bizNum1") + "-" + CS.$("#bizNum2") + "-" + CS.$("#bizNum3");
        axios.get(`/api/cst/is-able-regist-constructor/${bizNum}`)
        .then(res => {
            if(res.data.result) {
                CS.notification("info", t("key693"));
                this.bizNum = bizNum;
                this.isCorp = true;
            }else {
                CS.notification("warning", t("key694"));
                this.isCorp = false;
                this.bizNum = '';
            }
        })
        .catch(error => {
            CS.notification("error", error.response.data.message);
            this.isCorp = false;
            this.bizNum = '';
        })
    }


    async handleSubmit(e) {
        e.preventDefault();
        const data = new FormData(e.target);
        const { t } = this.props;
        if(this.isIdDuplicate) {
            CS.notification("warning", t("key695"));
            return;
        }

        let pw1 = data.get('pw1');
        let pw2 = data.get('pw2');
        if(!VS.isValidPasswd(pw1)) {
            document.getElementById("pw1").focus();
            return;
        }
        if(!VS.isValidPasswd(pw2)) {
            document.getElementById("pw2").focus();
            return;
        }
        if(pw1 !== pw2) {
            CS.notification("warning", t("key696"));
            return;
        }

        let bizNum = this.bizNum;
        if(bizNum === '') {
            CS.notification("error", t("key697"));
            return;
        }

        let email = data.get('mail1') + "@" + data.get('mail2')
        if(!VS.isValidEmail(email)) {
            document.getElementById("mail2").focus();
            return;
        }else {
            let res = await axios.get(`/api/account/email-check/${email}`);
            if(res.data.result) {
                CS.notification("warning", t("key698"));
                document.getElementById("mail1").focus();
                document.getElementById("mail1").value = "";
                return;
            }
        }

        let phone = data.get('phone1') + "-" + data.get('phone2') + "-" + data.get('phone3');
        if(!VS.isValidMobile(phone)) {
            document.getElementById("phone3").focus();
            return;
        }


        let item = {
            userId: data.get('userId'),
            userName: data.get('constructorName'),
            userType: "CST",
            password: data.get('pw1'),
            phone: phone,
            email: email,
            enabled: true,
            authorities: ['ROLE_CST'],
            constructor: {
                constructorName: data.get('constructorName'),
                ownerName: data.get('ownerName'),
                bizNum: bizNum,
                fileInfos: this.fileInfo.file,
                approveYn: false
            }
        }

        let result = await CS.create('/api/account', item);
        if(result.isSuccess)
            window.location.href = "/plant-status/main";

    }

    




    render() {
        const { t } = this.props;
        document.body.className="";
        const { idDuplicateMsg } = this.state;
        return (
            <>
            <div className="page-tit">
                <div className="container">
                    <h2 className="tit">{t("key671")}</h2>
                </div>
            </div>

            <div className="container">
                <form onSubmit={this.handleSubmit}>
                    <h3 className="content-tit1">{t("key672")}</h3>
                    <div className="card2">
                        <div className="form-inline3">
                            <div className="form-group">
                                <label htmlFor="constructorName" className="tit w120">{t("key673")}</label>
                                <input type="text" className="w550" name="constructorName" required />
                            </div>
                            <div className="form-group">
                                <label htmlFor="ownerName" className="tit w120">{t("key674")}</label>
                                <input type="text" className="w550" name="ownerName" required />
                            </div>
                            <div className="form-group">
                                <label htmlFor="tel1" className="tit w120">{t("key675")}</label>
                                <input type="text" className="w170" name="phone1" id="phone1" maxLength="3" onInput={(e) => {VS.onInput('number', e)}} required />
                                <span className="tel-unit">-</span>
                                <input type="text" className="w170" name="phone2" id="phone2" maxLength="4" onInput={(e) => {VS.onInput('number', e)}} required />
                                <span className="tel-unit">-</span>
                                <input type="text" className="w170" name="phone3" id="phone3" maxLength="4" onInput={(e) => {VS.onInput('number', e)}} required />
                            </div>
                            <div className="form-group">
                                <label htmlFor="tel1" className="tit w120">{t("key676")}</label>
                                <input type="text" className="w170" name="bizNum1" id="bizNum1" maxLength="3" onInput={(e) => {VS.onInput('number', e)}} required />
                                <span className="tel-unit">-</span>
                                <input type="text" className="w170" name="bizNum2" id="bizNum2" maxLength="3" onInput={(e) => {VS.onInput('number', e)}} required />
                                <span className="tel-unit">-</span>
                                <input type="text" className="w190" name="bizNum3" id="bizNum3" maxLength="5" onInput={(e) => {VS.onInput('number', e)}} required />
                                <button type="button" className="btn primary w160 ml-20" onClick={this.isCorpCheck}>{t("key677")}</button>
                            </div>
                            <div className="form-group">
                                <label htmlFor="file" className="tit w120">{t("key678")}</label>
                                <FileUpload className="w550" handleUploadFile={this.doSetFile} category="file" accept="image/*" />
                                <button type="button" className="btn primary w160 ml-20">{t("key679")}</button>
                            </div>
                        </div>
                    </div>

                    <h3 className="content-tit1">{t("key680")}</h3>
                    <div className="card2">
                        <div className="form-inline3">
                            <div className="form-group">
                                <label htmlFor="id" className="tit w120">{t("key681")}</label>
                                <span className="side-text">
                                    <input type="text" className="w550" name="userId" id="userId" placeholder="아이디" required />
                                    <strong className="warning-txt">{idDuplicateMsg}</strong>
                                </span>
                                <button type="button" className="btn primary w160 ml-20" onClick={this.idCheck}>{t("key683")}</button>
                            </div>
                            <div className="form-group">
                                <label htmlFor="pw1" className="tit w120">{t("key684")}</label>
                                <input type="password" className="w550" name="pw1" id="pw1" placeholder={t("key684")}
                                    onInput={(e) => {VS.onInput('onlyNumber', e)}} required
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor="pw2" className="tit w120">{t("key686")}</label>
                                <input type="password" className="w550" name="pw2" id="pw2" placeholder={t("key686")} required />
                            </div>
                            <div className="form-group">
                                <label htmlFor="mail1" className="tit w120">{t("key688")}</label>
                                <input type="text" className="w250" name="mail1" id="mail1" placeholder={t("key689")} onInput={(e) => {VS.onInput('eng&Number', e)}} required />
                                <span className="mail-unit">@</span>
                                <input type="text" className="w250" name="mail2" id="mail2" />
                            </div>
                        </div>
                    </div>
                    <div className="btn-areaC2">
                        <button type="button" className="btn" onClick={() => this.props.history.goBack()}>뒤로가기</button>
                        <button type="submit" className="btn primary">{t("key690")}</button>
                    </div>
                </form>
            </div>

            <div className="modal fade" id="endModal" tabIndex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered max-w450">
                    <div className="modal-content">
                        <div className="modal-body">
                            <p className="size15 text-center mt-15">{t("key699")}</p>
                            <div className="foot-btn">
                                <button type="button" className="btn primary" data-dismiss="modal">{t("key700")}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            </>
        )
    }
}

export default withTranslation()(Signup);
